import { CoachStatusEnum } from 'types/generated/client';
import { useGetCurrentUser } from 'hooks/useGetCurrentUser';
import { useViewer } from 'hooks/useViewer';
import CoachLoggedInScreen from 'screens/CoachLoggedInScreen';
import PlayerHomeV3 from 'screens/PlayerHomeV3';

const AnonHomePage = () => {
  const { isAnonymousSession, isSessionLoading } = useViewer();
  const { user, loading, called } = useGetCurrentUser();

  // The V3 home serves anonymous viewers too, so it also covers the loading window.
  if (isSessionLoading || isAnonymousSession || loading || !called) {
    return <PlayerHomeV3 />;
  }

  if (user?.coachStatus === CoachStatusEnum.Active) {
    return <CoachLoggedInScreen />;
  }

  return <PlayerHomeV3 />;
};

export default AnonHomePage;
